import React, { Component, Fragment } from "react";

export default class NovoForm extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    render() {
        let { unidade, metas, titulo, subtitulo } = this.props;
        let meses = ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa/ZEUS"];
        let name = ["numeroAtendimento", "horasTecnicas", "receita", "despesa"];
        return (
            <Fragment>
            <div className="content">
                <div className="row">
                    <div className="col-md-12 ml-auto mr-auto">
                        <div className="card card-user">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5 className="card-title">{titulo || "Geral Total"}</h5>
                                        <h6>{subtitulo || "DR"}</h6>
                                        {/* <h6>{"Soluções em Tecnologia e Inovação - STI"}</h6> */}
                                        {this.props.children[0]}
                                        <hr />

                                        <div className="table table-striped table-hover table-borderless table-sm">
                                            {this.props.children[1]}
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </Fragment>
        )
    }
}